var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMHome = function SvgIconMHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.836 7.562a.61.61 0 0 1-.486-.26.676.676 0 0 1 .121-.905L7.207.99a2.54 2.54 0 0 1 3.186 0l6.736 5.407c.269.213.321.62.121.906a.584.584 0 0 1-.85.13L9.655 2.024a1.36 1.36 0 0 0-1.719 0L1.2 7.432a.6.6 0 0 1-.364.13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.188 17.571H4.412c-1.45 0-2.63-1.257-2.63-2.8V9.142c0-.36.269-.647.607-.647.339 0 .608.287.608.647v5.629c0 .832.634 1.506 1.415 1.506h8.776c.781 0 1.415-.674 1.415-1.506V6.194c0-.36.269-.647.607-.647.339 0 .608.286.608.647v8.577c0 1.543-1.18 2.8-2.63 2.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.547 14.364H6.044c-.339 0-.608-.286-.608-.647 0-.36.27-.647.608-.647h5.503c.339 0 .608.287.608.647s-.27.647-.608.647"
  })));
};
export default SvgIconMHome;